// import crypto from 'crypto'
export const DEVICE_ID_KEY = 'deviceId'

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * Returns existing deviceId from localStorage, or creates and stores a new UUID.
 */
export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY)
    if (id) {
      return id
    }
    id = generateUuid()
    localStorage.setItem(DEVICE_ID_KEY, id)
    return id
  } catch {
    return generateUuid()
  }
}
